import TyFaceBox from './TyFaceBox.vue'
export default TyFaceBox



// WEBPACK FOOTER //
// ./src/components/ty-facebox/index.js